export enum Status {
    LoggedOut = 'logged_out',
    Available = 'available',
    AvailableOnDemand = 'available_on_demand',
    OnBreak = 'on_break',
    Break = 'break',
    NotAssign = 'not_assign', // custom status without relation with status
    Waiting = 'waiting',
    Busy = 'busy',
    None = '',
}

export class AgentStatus {
    static isLoggedOut(status: Status): boolean {
        return status === Status.LoggedOut;
    }

    static isAvailable(status: Status): boolean {
        return status === Status.Available;
    }

    static isAvailableOnDemand(status: Status): boolean {
        return status === Status.AvailableOnDemand;
    }

    static isOnBreak(status: Status): boolean {
        return status === Status.OnBreak;
    }

    static isWaiting(status: Status): boolean {
        return status === Status.OnBreak;
    }

    static isBusy(status: Status): boolean {
        return status === Status.Busy;
    }

    static fromString(status: string): Status {
        const normalizedStatus = status.toLowerCase();

        switch (normalizedStatus) {
        case 'on_break':
        case 'almuerzo':
        case 'break':
        case 'lunch':
        case 'pausa':
            return Status.OnBreak;
        case 'logged_out':
            return Status.LoggedOut;
        case 'available':
            return Status.Available;
        case 'not_assign':
            return Status.NotAssign;
        case 'available_on_demand':
            return Status.AvailableOnDemand;
        case 'busy':
        case 'ocupado':
        case 'ocupa3':
            return Status.Busy;
        default:
            return Status.None;
        }
    }

    /**
     * Etiqueta custom que el webphone manda junto con el DND (ITPCX-10006):
     * una pausa ("Bano") o el estado configurado por la empresa para la llamada.
     * La etiqueta generica de ocupado no agrega informacion, asi que no se muestra.
     */
    static customStatusDetail(message?: string): string {
        const detail = (message || '').trim();

        if (detail === '' || AgentStatus.fromString(detail) === Status.Busy) {
            return '';
        }

        return detail;
    }
}
